<script lang="ts">
    import { ActiveTopicStore, ActiveTopic } from "$/stores/extension/ActiveTopicStore";
    import { AppStore } from "$/stores/AppStore";
    import { tooltip } from "$/utils/tooltip";
    import { cleanUrl, generateDocumentObject } from "$/utils/Utils";
    import { CardTitleUtils } from "./card/CardTitle/CardTitleUtils";
    import { TokenStore } from "$/stores/TokenStore";
    import { derived } from "svelte/store";
    import { PreferencesStore } from "$/stores/global/PreferencesStore";
    import { SelectionUtils } from "$/utils/SelectionUtils";

    let loading = false;
    
    $: activeBookmark = $ActiveTopic ? ActiveTopicStore.getBookmarkByUrl(window.location.href) : undefined;

    // focus bookmark on topic change
    const activeTopicChanged = derived(ActiveTopic, $topic => $topic?.id);
    $: $activeTopicChanged, focusBookmark();
    const focusBookmark = () => {
        if($PreferencesStore.focusBookmarkOnStartup) {
            requestAnimationFrame(() => {
                if(activeBookmark) AppStore.setFocused({ snippetId: activeBookmark.id });
            })
        }
    }

    const handleOnClick = async () => {
        if(activeBookmark) {
            AppStore.setFocused({ snippetId: activeBookmark.id });
        } else {
            bookmarkPage();
        }
    }
    const bookmarkPage = async () => {
        if (loading) return;

        const title = CardTitleUtils.generateTitle(document);
        const description = SelectionUtils.getContentFromDocumentDescription(document);

        const cleanedUrl = cleanUrl(document.location.href);

        let snippet = {
            id: null,
            name: title,
            nameSuggestion: title,
            comments: [],
            content: description,
            url: cleanedUrl,
            createdBy: $TokenStore.user,
            createdOn: new Date().getTime(),
            bookmark: true,
            document: generateDocumentObject(window.location.href)
        };

        loading = true;

        const newSnippet = await ActiveTopicStore.createSnippet(snippet);
        AppStore.setFocused({ snippetId: newSnippet.id });

        loading = false;
    };
</script>

<button
    use:tooltip={activeBookmark ? "Show Bookmark" : "Bookmark this page"}
    on:click={handleOnClick}
    class="bookmark-button"
    class:bookmark-button--active={activeBookmark}
>
    {#if loading}
        <svg
            class="bookmark-button__spinner"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
            />
        </svg>
    {:else}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
            />
        </svg>
    {/if}
</button>

<style>
    .bookmark-button {
        @apply flex justify-center items-center w-10 h-10 rounded-full border border-solid border-gray-800 bg-white outline-none hover:bg-gray-200 cursor-pointer !important;
    }

    .bookmark-button svg {
        @apply reset h-5 w-5 cursor-pointer text-gray-800 !important;
    }

    .bookmark-button--active {
        @apply bg-gray-500 hover:bg-gray-700 !important;
    }

    .bookmark-button--active svg {
        @apply text-white !important;
    }

    .bookmark-button__spinner {
        @apply relative left-1 top-0 animate-spin !important;
    }
</style>
